(() => {
  if (window.vyraAtelierInitialized) return;
  window.vyraAtelierInitialized = true;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const motion = () => !reduced.matches && document.body.dataset.motion !== 'false';
  const behavior = () => motion() ? 'smooth' : 'instant';
  const root = window.Shopify?.routes?.root || '/';
  const strings = JSON.parse($('#ThemeStrings')?.textContent || '{}');
  let previousY = scrollY, scheduled = false;
  const scrollSelectors = ['[data-finesse]', '[data-scroll-detail]', '[data-mosaic]', '[data-story]', '[data-parallax]', '[data-packs],[data-ribbon]', '[data-product-section]'];
  let scrollGroups = scrollSelectors.map(selector => $$(selector));
  const refreshScrollTargets = () => { scrollGroups = scrollSelectors.map(selector => $$(selector)); };
  const propertyValues = new WeakMap();
  function frame() {
    scheduled = false;
    const y = scrollY, height = innerHeight, enabled = motion(), writes = [];
    const property = (el, key, value) => {
      value = String(value);
      let values = propertyValues.get(el);
      if (!values) { values = new Map(); propertyValues.set(el, values); }
      if (values.get(key) === value) return;
      values.set(key, value);
      writes.push(() => el.style.setProperty(key, value));
    };
    const header = $('[data-header]');
    const down = y > previousY;
    const hidden = y > 350 && down && header && !header.contains(document.activeElement) && !$('.mega[open]') && !$('[data-vyra-locale][open]');
    writes.push(() => {
      header?.classList.toggle('is-floating', y > 180);
      header?.classList.toggle('is-hidden', !!hidden);
    });
    previousY = y;
    scrollGroups.forEach((elements, group) => elements.forEach(el => {
      if (!el.isConnected) return;
      const r = el.getBoundingClientRect();
      if (group === 0) property(el, '--finesse', enabled ? Math.max(0, Math.min(1, -r.top / Math.max(1, r.height - height) * 1.4)).toFixed(4) : 1);
      if (group === 1) property(el, '--detail-progress', enabled ? Math.max(0, Math.min(1, -r.top / Math.max(1, r.height - height))).toFixed(4) : 1);
      if (group === 2) property(el, '--mosaic-progress', enabled ? Math.max(0, Math.min(1, (height - r.top) / (height + r.height))).toFixed(4) : 0);
      if (group === 3) property(el, '--progress', enabled ? Math.max(0, Math.min(1, -r.top / Math.max(1, r.height - height))).toFixed(4) : 0);
      if (group === 4 && r.bottom > 0 && r.top < height) property(el, '--image-shift', enabled ? Math.max(-35, Math.min(35, (r.top - height / 2) * -.07)) + 'px' : '0px');
      if (group === 5 && r.bottom >= 0 && r.top <= height) property(el, '--scroll', enabled ? Math.max(0, Math.min(1, (height - r.top) / (height + r.height))).toFixed(4) : .5);
      if (group === 6) {
        const form = $('.product-form', el), sticky = $('.product-sticky', el);
        const visible = !!form && form.getBoundingClientRect().bottom < 0 && r.bottom > 0;
        writes.push(() => sticky?.classList.toggle('is-visible', visible));
      }
    }));
    writes.forEach(write => write());
  }
  function schedule() { if (!scheduled) { scheduled = true; requestAnimationFrame(frame); } }
  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule, { passive: true });
  reduced.addEventListener('change', schedule);
  addEventListener('pageshow', schedule);
  addEventListener('load', schedule);
  document.fonts?.ready.then(schedule);
  document.addEventListener('load', event => { if (event.target instanceof HTMLImageElement) schedule(); }, true);
  const observer = new IntersectionObserver(entries => entries.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('is-revealed'); observer.unobserve(e.target); }
  }), { threshold: .12 });
  const videoObserver=new IntersectionObserver(entries=>entries.forEach(({target:video,isIntersecting})=>{if(isIntersecting){const source=$('source[data-src]',video);if(source){source.src=source.dataset.src;source.removeAttribute('data-src');video.load();}if(motion()&&video.dataset.userPaused!=='true')video.play().catch(()=>{});}else video.pause();}),{threshold:.15});
  const counter = new IntersectionObserver(entries => entries.forEach(e => {
    if (!e.isIntersecting) return;
    counter.unobserve(e.target);
    const el = e.target, m = el.textContent.match(/^(\D*)(\d+(?:[.,]\d+)?)([\s\S]*)$/);
    if (!m || !motion()) return;
    const end = parseFloat(m[2].replace(',', '.')), decimals = (m[2].split(/[.,]/)[1] || '').length, comma = m[2].includes(','), start = performance.now();
    const tick = now => {
      if (!el.isConnected) return;
      if (!motion()) { el.textContent = m[0]; return; }
      const p = Math.min(1, (now - start) / 1400), value = (end * (1 - Math.pow(1 - p, 3))).toFixed(decimals);
      el.textContent = m[1] + (comma ? value.replace('.', ',') : value) + m[3];
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }), { threshold: .4 });
  reduced.addEventListener('change',()=>{$$('video.ambient-video').forEach(v=>{if(!motion())v.pause();});});
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  let tilted = null, pointer = null, tiltFrame = 0;
  function resetTilt() {
    if (!tilted) return;
    tilted.classList.remove('is-tilting');
    tilted.style.removeProperty('--rx'); tilted.style.removeProperty('--ry'); tilted = null;
  }
  function updateTilt() {
    tiltFrame = 0;
    const card = pointer?.card;
    if (!card?.isConnected || !fine.matches || !motion()) { resetTilt(); return; }
    const r = card.getBoundingClientRect();
    if (tilted !== card) resetTilt();
    tilted = card;
    card.classList.add('is-tilting');
    card.style.setProperty('--ry', (((pointer.x - r.left) / r.width - .5) * 10).toFixed(2) + 'deg');
    card.style.setProperty('--rx', ((.5 - (pointer.y - r.top) / r.height) * 8).toFixed(2) + 'deg');
  }
  document.addEventListener('pointermove', e => {
    pointer = { card: e.target instanceof Element ? e.target.closest('[data-tilt]') : null, x: e.clientX, y: e.clientY };
    if (!tiltFrame && (pointer.card || tilted)) tiltFrame = requestAnimationFrame(updateTilt);
  }, { passive: true });
  document.addEventListener('pointerout', e => { if (!e.relatedTarget) { pointer = null; resetTilt(); } });
  reduced.addEventListener('change', resetTilt);
  fine.addEventListener('change', resetTilt);
  function split(el) {
    if (el.dataset.split || el.children.length) return;
    const text = el.textContent.trim();
    if (!text) return;
    el.dataset.split = 'true';
    el.setAttribute('aria-label', text);
    el.textContent = '';
    text.split(/\s+/).forEach((word, i) => {
      const outer = document.createElement('span'), inner = document.createElement('span');
      outer.className = 'word'; outer.setAttribute('aria-hidden', 'true');
      inner.style.transitionDelay = (i * 45) + 'ms'; inner.textContent = word;
      outer.append(inner); el.append(outer, ' ');
    });
  }
  const initializedVideos = new WeakSet(), initializedGalleries = new WeakSet(), initializedRails = new WeakSet(), counted = new WeakSet();
  function init(scope = document) {
    refreshScrollTargets();
    $$('video.ambient-video',scope).forEach(video=>{if(initializedVideos.has(video))return;initializedVideos.add(video);const button=$('[data-video-toggle]',video.closest('.cinema'));const update=()=>{if(!button)return;button.setAttribute('aria-pressed',String(!video.paused));button.setAttribute('aria-label',video.paused?strings.play:strings.pause);button.firstElementChild.textContent=video.paused?'▶':'Ⅱ';};video.addEventListener('play',update);video.addEventListener('pause',update);videoObserver.observe(video);});
    if (motion()) document.documentElement.classList.add('is-animated');
    if (motion() && !window.Shopify?.designMode) $$('h2[data-reveal]', scope).forEach(split);
    const packQuantity = Number(new URLSearchParams(location.search).get('qty'));
    if (packQuantity > 1) $$('.product-form [name=quantity]', scope).forEach(input => { input.value = Math.min(Number(input.max) || packQuantity, packQuantity); });
    $$('[data-reveal]', scope).forEach(el => observer.observe(el));
    $$('.metric-value,.evidence-number', scope).forEach(el => { if (!counted.has(el)) { counted.add(el); counter.observe(el); } });
    $$('[data-gallery]', scope).forEach(gallery => {
      if (initializedGalleries.has(gallery)) return;
      initializedGalleries.add(gallery);
      const track = $('.gallery-track', gallery);
      track.addEventListener('scroll', () => {
        const index = Math.round(track.scrollLeft / track.clientWidth);
        $$('[data-slide]:not([hidden])', gallery).forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index)));
      }, { passive: true });
    });
    $$('noscript', scope).forEach(el => el.remove());
    $$('.option-values', scope).forEach(group => {
      const labels = [...group.children];
      if (labels.every(label => /^\d+(\.\d+)?$/.test($('input', label).value))) labels.sort((a,b) => Number($('input',a).value) - Number($('input',b).value)).forEach(label => group.append(label));
    });
    $$('.product-form input[name=id]', scope).forEach(input => { input.disabled = !input.value; });
    $$('[data-card-track]', scope).forEach(track => {
      if (initializedRails.has(track)) return;
      initializedRails.add(track);
      const update = () => {
        const section = track.closest('section');
        $('[data-rail-prev]', section).disabled = track.scrollLeft <= 2;
        $('[data-rail-next]', section).disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      };
      track.addEventListener('scroll', update, { passive: true }); update();
    });
    frame();
  }
  function open(dialog) { if (dialog && !dialog.open) dialog.showModal(); }
  function galleryTo(gallery, index) {
    const track = $('.gallery-track', gallery);
    const max = $$('.gallery-slide:not([hidden])', gallery).length - 1;
    track.scrollTo({ left: Math.max(0, Math.min(max, index)) * track.clientWidth, behavior: behavior() });
  }
  async function refreshCart() {
    const url = new URL(root, location.origin);
    url.searchParams.set('section_id', 'cart-fragment');
    const response = await fetch(url);
    if (!response.ok) throw new Error(strings.error);
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const content = $('[data-cart-fragment]', html);
    if (!content) throw new Error(strings.error);
    $$('[data-cart-content]').forEach(el => { el.innerHTML = content.innerHTML; });
    const cart = await fetch(root + 'cart.js').then(r => r.json());
    $$('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.toggleAttribute('data-zero', !cart.item_count); });
  }
  let cartBusy = false;
  async function changeCart(key, quantity, trigger) {
    if (cartBusy) return;
    cartBusy = true;
    const form = trigger.closest('form');
    form?.setAttribute('aria-busy', 'true');
    try {
      const r = await fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
      const result = await r.json();
      if (!r.ok) throw new Error(result.description || strings.error);
      await refreshCart();
    } catch (e) { const status = $('[data-cart-status]', form); if (status) status.textContent = e.message; }
    finally { cartBusy = false; form?.removeAttribute('aria-busy'); }
  }
  document.addEventListener('click', async e => {
    const trigger = e.target.closest('button,a');
    if (!trigger) return;
    if(trigger.matches('[data-app-tab]')){const section=trigger.closest('.app-showcase');const panel=document.getElementById(trigger.getAttribute('aria-controls'));$$('[data-app-tab]',section).forEach(b=>b.setAttribute('aria-selected',String(b===trigger)));$('.phone-rail',section).scrollTo({left:panel.offsetLeft-panel.parentElement.offsetLeft,behavior:behavior()});}
    if (trigger.matches('[data-qty]')) {
      const input = $('[name=quantity]', trigger.closest('.quantity-row'));
      const step = Number(input.step) || 1, min = Number(input.min) || 1, max = Number(input.max) || Infinity;
      input.value = Math.max(min, Math.min(max, (Number(input.value) || min) + step * Number(trigger.dataset.qty)));
    }
    if (trigger.matches('[data-open]')) open(document.getElementById(trigger.dataset.open));
    if (trigger.matches('[data-video-toggle]')) { const video=$('video',trigger.closest('.cinema')); if(video.paused){video.dataset.userPaused='false';video.play().catch(()=>{});}else{video.dataset.userPaused='true';video.pause();} }
    if (trigger.matches('[data-close]')) trigger.closest('dialog')?.close();
    if (trigger.matches('[data-cart-open]')) { e.preventDefault(); open($('#CartDrawer')); try { await refreshCart(); } catch {} }
    if (trigger.matches('[data-cart-remove]')) { e.preventDefault(); await changeCart(trigger.dataset.cartRemove, 0, trigger); }
    if (trigger.matches('.expand-card')) {
      const card = trigger.closest('.life-card');
      const expanded = trigger.getAttribute('aria-expanded') !== 'true';
      $$('.life-card', card.parentElement).forEach(sibling => {
        const active = sibling === card && expanded;
        sibling.classList.toggle('is-expanded', active);
        $('.expand-card', sibling).setAttribute('aria-expanded', String(active));
        $('.card-extra', sibling).hidden = !active;
      });
      setTimeout(() => card.parentElement.scrollTo({ left: card.offsetLeft - card.parentElement.offsetLeft - (innerWidth < 750 ? 24 : 64), behavior: behavior() }), motion() ? 250 : 0);
    }
    if (trigger.matches('[data-rail-next],[data-rail-prev]')) {
      const track = $('[data-card-track]', trigger.closest('section'));
      track.scrollBy({ left: ($('.life-card', track).getBoundingClientRect().width + 24) * (trigger.hasAttribute('data-rail-next') ? 1 : -1), behavior: behavior() });
    }
    if (trigger.matches('[data-slide],[data-gallery-next],[data-gallery-prev]')) {
      const gallery = trigger.closest('[data-gallery]');
      const track = $('.gallery-track', gallery);
      galleryTo(gallery, trigger.hasAttribute('data-slide') ? Number(trigger.dataset.slide) : Math.round(track.scrollLeft / track.clientWidth) + (trigger.hasAttribute('data-gallery-next') ? 1 : -1));
    }
    if (trigger.matches('[data-zoom]')) {
      const dialog = $('.zoom-dialog', trigger.closest('[data-product-section]'));
      $('img', dialog).src = trigger.dataset.zoom; open(dialog);
    }
    if (trigger.matches('[data-sticky-add]')) $('.product-form', trigger.closest('[data-product-section]')).requestSubmit($('.add-button', trigger.closest('[data-product-section]')));
  });
  document.addEventListener('click', e => {
    if (e.target instanceof HTMLDialogElement) {
      const r = e.target.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) e.target.close();
    }
    $$('.mega[open]').forEach(el => { if (!el.contains(e.target)) el.open = false; });
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') $$('.mega[open]').forEach(el => { el.open = false; $('summary', el).focus(); }); });
  document.addEventListener('change', async e => {
    const input = e.target;
    if (input.matches('[data-cart-key]') && input.validity.valid) await changeCart(input.dataset.cartKey, Number(input.value), input);
    if (!input.matches('[data-option-id]')) return;
    const section = input.closest('[data-product-section]');
    const data = JSON.parse($('[data-variants]', section).textContent);
    const selected = $$('fieldset input:checked', section).map(el => el.value);
    const variant = data.find(v => v.options.every((value, i) => value === selected[i]));
    const form = $('.product-form', section);
    const id = $('input[name=id]', form);
    id.value = variant?.id || ''; id.disabled = !variant;
    const price = $('.product-price', section); price.textContent = variant?.price || strings.unavailable;
    if (variant?.compare) { const s = document.createElement('s'); s.textContent = variant.compare; price.append(' ', s); }
    if (variant?.save) { const badge = document.createElement('span'); badge.className = 'price-badge'; badge.textContent = '−' + variant.save + ' %'; price.append(' ', badge); }
    const stock = $('[data-stock]', section);
    if (stock) { const low = Boolean(variant?.available && variant.stock); stock.hidden = !low; stock.textContent = low ? stock.dataset.template.replace('__N__', variant.stock) : ''; }
    const label = variant ? variant.available ? strings.add : strings.sold_out : strings.unavailable;
    $$('.add-button,[data-sticky-add]', section).forEach(button => { button.disabled = !variant?.available; button.textContent = label; });
    const quantity = $('[name=quantity]', form);
    quantity.min = variant?.min || 1; quantity.step = variant?.step || 1;
    if (variant?.max) quantity.max = variant.max; else quantity.removeAttribute('max');
    quantity.value = Math.max(Number(quantity.min), Math.min(Number(quantity.max) || Infinity, Number(quantity.value) || 1));
    $('.product-sticky strong', section).textContent = variant?.price || '';
    $$('fieldset', section).forEach((fieldset, index) => {
      $('legend span', fieldset).textContent = window.VyraText(selected[index]);
      $$('input', fieldset).forEach(option => {
        const available = data.some(v => v.available && v.options.every((value, i) => value === (i === index ? option.value : selected[i])));
        option.closest('label').classList.toggle('is-unavailable', !available);
      });
    });
    if ($('[data-campaign-gallery]', section)) {
      const gallery=$('[data-campaign-gallery]',section);const finish=window.VyraFinish(variant?.options[0]||'');
      $$('[data-finish]',gallery).forEach(el=>{el.hidden=el.dataset.finish!==finish;});galleryTo(gallery,0);
    } else if (variant?.media) {
      const slides = $$('.gallery-slide', section);
      const index = slides.findIndex(slide => slide.dataset.mediaId === String(variant.media));
      if (index >= 0) galleryTo($('[data-gallery]', section), index);
    }
    if (location.pathname === section.dataset.url) {
      const url = new URL(location.href);
      if (variant) url.searchParams.set('variant', variant.id); else url.searchParams.delete('variant');
      history.replaceState({}, '', url);
    }
  });
  document.addEventListener('submit', async e => {
    const form = e.target;
    if (!form.matches('.product-form')) return;
    if (e.submitter && !e.submitter.matches('.add-button')) return;
    e.preventDefault();
    if (form.getAttribute('aria-busy') === 'true') return;
    const status = $('[data-product-status]', form);
    status.textContent = strings.loading;
    form.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(root + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || strings.error);
      status.textContent = strings.added;
      try { await refreshCart(); open($('#CartDrawer')); } catch { location.assign(root + 'cart'); }
    } catch (error) { status.textContent = error.message || strings.error; }
    finally { form.removeAttribute('aria-busy'); }
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    $$('[data-reveal]', event.target).forEach(el => observer.unobserve(el));
    $$('.metric-value,.evidence-number', event.target).forEach(el => counter.unobserve(el));
    $$('video.ambient-video', event.target).forEach(video => { videoObserver.unobserve(video); video.pause(); });
    scrollGroups = scrollGroups.map(elements => elements.filter(el => !event.target.contains(el)));
    if (tilted && event.target.contains(tilted)) { pointer = null; resetTilt(); }
    schedule();
  });
  document.addEventListener('shopify:section:reorder', schedule);
  document.addEventListener('shopify:block:select', event => {
    const card = event.target.closest('.life-card');
    if (card && !card.classList.contains('is-expanded')) $('.expand-card', card).click();
  });
  init();
})();

